import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import toast from "react-hot-toast";
import { handleError } from "../../utils/handleError";
import { addNewRole, getAllRolesAPI } from "../../services/roles/roleService";
import { setListRoles } from "../../redux/slice/roles";
import { useDispatch } from "react-redux";

const RoleModal = ({ open, setOpen, roleData, setLoading }) => {
  // Estado inicial del formulario
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  // Efecto para cargar datos cuando se edita
  useEffect(() => {
    if (roleData) {
      setFormData({
        name: roleData.name || "",
        description: roleData.description || "",
      });
      setIsEditMode(true);
    } else {
      resetForm();
      setIsEditMode(false);
    }
  }, [roleData]);

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
    });
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Limpiar error cuando el usuario escribe
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "El nombre del rol es requerido";
    } else if (formData.name.trim().length < 3) {
      newErrors.name = "El nombre debe tener al menos 3 caracteres";
    }

    if (!formData.description.trim()) {
      newErrors.description = "La descripción es requerida";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      if (validateForm()) {
        // Preparar datos para enviar a la API
        const dataToSend = {
          name: formData.name.trim(),
          description: formData.description.trim(),
        };
        await addNewRole(dataToSend);
        const listRoles = await getAllRolesAPI();
        dispatch(setListRoles({ listRoles: listRoles }));
        setOpen(false);
        setLoading(false);
        toast.success(`El rol ${formData?.name} se creo con éxito. `);
      }
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(`No se pudo crear el rol. \n ${message}`);
    }
  };

  const handleClose = () => {
    resetForm();
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEditMode ? "Editar Rol" : "Crear Nuevo Rol"}</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre del Rol"
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={!!errors.name}
                helperText={errors.name}
                margin="normal"
                variant="outlined"
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Descripción"
                name="description"
                value={formData.description}
                onChange={handleChange}
                error={!!errors.description}
                helperText={errors.description}
                margin="normal"
                variant="outlined"
                multiline
                rows={4}
                required
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={handleClose} color="whithe">
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{ backgroundColor: "#e7ef7d" }}
          >
            {isEditMode ? "Guardar Cambios" : "Crear Rol"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default RoleModal;
